import React from 'react';
import { ApiRoutesDisplay } from '../../components/apiroutes/ApiRoutesDisplay';
import './styles.css';

const ApiRoutes = () => {
  return (
    <div className="api-routes-page">
      <ApiRoutesDisplay />
    </div>
  );
};

export default ApiRoutes; 